<template>
    <div class="input-frame">
        <input type="text" v-model="textInner"/>
        <div class="clear-button"
             @click="onClickClear">
            <div class="x-icon"></div>
        </div>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, toRefs} from "vue";

export default defineComponent({
    name: "ClearableInput",
    props: {
        text: {
            type: String,
            default: ""
        },
    },
    emits:[ "update:text", ],
    setup(props, { emit }) {

        const { text } = toRefs(props)
        const textInner = computed({
            get: (): string => {
                return text.value
            },
            set: (val: string) => {
                emit("update:text", val)
            }
        })

        const onClickClear = () => {
            textInner.value = ""
        }

        return {
            textInner,
            onClickClear,
        }
    }
})
</script>

<style scoped lang="scss">
.input-frame {
    position: relative;
    border: 1px solid lightgray;
    border-radius: 3px;
    height: 40px;

    input {
        border: none;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: calc(100% - 30px);
        outline: none;
        text-indent: 5px;
    }

    .clear-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        //background-color: blue;

        &:hover {
            opacity: 0.7;
        }

        &:active {
            opacity: 0.5;
        }

        .x-icon {
            position: absolute;
            width: 25px;
            height: 25px;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            //background-color: red;

            &::before {
                content: "";
                position: absolute;
                width: 20px;
                height: 3px;
                border-radius: 1.5px;
                transform: rotate(45deg);
                background-color: lightgray;
                top: 10px;
                left: 2px;
            }

            &::after {
                content: "";
                position: absolute;
                width: 20px;
                height: 3px;
                border-radius: 1.5px;
                transform: rotate(-45deg);
                background-color: lightgray;
                top: 10px;
                left: 2px;
            }
        }
    }
}
</style>